import { openBlock as c, createElementBlock as o, createElementVNode as t } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}, n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M10 9.59a.63.63 0 0 1-.625-.625V6.19A.63.63 0 0 1 10 5.565a.63.63 0 0 1 .625.625v2.775c0 .35-.283.625-.625.625"
}, null, -1), l = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M10.017 17.782a20 20 0 0 1-6.334-1.025c-.758-.25-1.333-.791-1.583-1.475-.25-.683-.167-1.466.242-2.15L3.4 11.366c.233-.392.442-1.125.442-1.584v-1.75a6.18 6.18 0 0 1 6.175-6.175 6.18 6.18 0 0 1 6.175 6.175v1.75c0 .45.208 1.192.441 1.584l1.059 1.766c.391.65.458 1.425.2 2.134a2.47 2.47 0 0 1-1.542 1.491 19.7 19.7 0 0 1-6.333 1.025m0-14.666A4.93 4.93 0 0 0 5.092 8.04v1.75c0 .675-.267 1.65-.617 2.225L3.417 13.79c-.217.358-.267.741-.142 1.075s.408.583.808.716a18.94 18.94 0 0 0 11.884 0c.358-.116.633-.383.758-.733.133-.35.092-.733-.1-1.058l-1.058-1.767c-.35-.575-.617-1.55-.617-2.225V8.05c-.008-2.725-2.217-4.933-4.933-4.933"
}, null, -1), r = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M10 19.908a3.42 3.42 0 0 1-2.4-1 3.42 3.42 0 0 1-1-2.4h1.25a2.16 2.16 0 0 0 2.15 2.15c1.183 0 2.15-.967 2.15-2.15h1.25c0 1.875-1.525 3.4-3.4 3.4"
}, null, -1), a = [
  n,
  l,
  r
];
function i(s, d) {
  return c(), o("svg", e, [...a]);
}
const _ = { render: i };
export {
  _ as default,
  i as render
};
